import { API_DEV } from "constants/api";

import { header, handleAPIResult, serialize, formatMaterialFilters } from "utils";

export const projectService = {
  list,
  homeList,
  get,
  create,
  update,
  powerBiUrl,
};

function list(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/projects?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function homeList() {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/projects/homepage", getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function get(id) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/projects/" + id, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function create(project) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      project: project,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/projects", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function update(project) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      project: project,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/projects/" + project.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Retourne l'url pour power bi
function powerBiUrl() {
  return API_DEV + "/projects";
}
